import { render, staticRenderFns } from "./ChangeAvatarPage.vue?vue&type=template&id=528d0ae4&scoped=true"
import script from "./ChangeAvatarPage.vue?vue&type=script&lang=js"
export * from "./ChangeAvatarPage.vue?vue&type=script&lang=js"
import style0 from "./ChangeAvatarPage.vue?vue&type=style&index=0&id=528d0ae4&prod&lang=stylus&scoped=true"
import style1 from "./ChangeAvatarPage.vue?vue&type=style&index=1&id=528d0ae4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528d0ae4",
  null
  
)

export default component.exports